import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CompleteActionFragment = { __typename?: 'Action', id: string, active?: boolean | null, event?: string | null, name?: string | null, description?: string | null, url?: string | null, insertedAt?: string | null, updatedAt?: string | null, multiAsset?: boolean | null, workspace?: { __typename?: 'Workspace', id: string, name: string, projectCount?: number | null, images?: { __typename?: 'Images', image64?: string | null } | null } | null };

export const CompleteAction = /*#__PURE__*/ gql`
    fragment CompleteAction on Action {
  id
  active
  event
  name
  description
  url
  insertedAt
  updatedAt
  multiAsset
  workspace {
    id
    name
    images {
      image64
    }
    projectCount
  }
}
    ` as unknown as DocumentNode<CompleteActionFragment, unknown>;

        

        
export const useCompleteActionFragment = (
  input: string | Omit<UseFragmentOptions<CompleteActionFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Action' } };
    return input;
  })();

  return useFragment<CompleteActionFragment>({
    fragment: CompleteAction,
    fragmentName: 'CompleteAction',
    ...options,
  });
};
  
        